import rootStore from 'reducers';
import { SESSION } from 'actions/session'
import { ONLY_SHIPPING_LABEL, ITEM_ESTIMATION } from 'actions/item'

export default (state = null, action) => {
    let user;
    switch (action.type) {
        case SESSION:
            return action.payload;
        case ONLY_SHIPPING_LABEL:
            user = rootStore.getState().Session.userData;
            if(user) {
                user.updateUserData({local_time: action.payload.data.user?.local_time || new Date().toISOString()});
                return Object.assign({}, state, {userData: user});
            }
        case ITEM_ESTIMATION:
            user = rootStore.getState().Session.userData;
            if(user && action.payload.data.user) {
                user.updateUserData({account_manager: action.payload.data.user.account_manager});
                return Object.assign({}, state, {userData: user});
            }
    }

    return state;
}